import styled, { css } from 'styled-components';

import { Submit, UpdateMessage } from 'libs/ui';

export const FormHeader = styled.p`
  border-bottom: solid 1px var(--cp-border, #595d64);
  padding: 0 0 15px 0;
  font-size: 20px;
  color: var(--cp-text, #fff);
  opacity: 0.6;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      font-size: 16px;
      font-weight: 600;
      opacity: 1;
      padding-bottom: 12px;
      margin-bottom: 1px;
    `}
`;

export const SaveButton = styled(Submit)`
  position: absolute;
  bottom: 30px;
  right: 30px;
  &[disabled] {
    cursor: not-allowed;
  }
`;

export const UpdateMessageBox = styled(UpdateMessage)`
  /* bottom: -100px;
  left: 180px; */
  width: 270px;
  left: 15px;
  bottom: 15px;
  position: fixed;
`;

export const TariffData = styled.div`
  width: 590px;
  position: relative;
`